import { ExchangeTheme } from './exchange';
import { SeatMapTheme } from './seat-map';
import Refund from './refund/ui/theme';
import * as Upsale from './upsale/ui/Upsale/Upsale.css';
import RefundServices from './refund-services/ui/theme';

export default {
	Upsale: { Upsale },
	Exchange: ExchangeTheme,
	SeatMap: SeatMapTheme,
	Refund,
	RefundServices
};
